import { gql } from '@apollo/client';

export * from './cancelSubscription.mutation.generated';

export const CANCEL_SUBSCRIPTION = gql`
  mutation cancelSubscription($clientMutationId: String) {
    cancelSubscription(input: { clientMutationId: $clientMutationId }) {
      success
      errors
      company {
        id
        subscriptionCancellationRequestedAt
      }
    }
  }
`;
